import { render, staticRenderFns } from "./SupplierLhtInvitation.vue?vue&type=template&id=540ec78a&scoped=true&"
import script from "./SupplierLhtInvitation.vue?vue&type=script&lang=js&"
export * from "./SupplierLhtInvitation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierLhtInvitation.vue?vue&type=style&index=0&id=540ec78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ec78a",
  null
  
)

export default component.exports